import { DateTime } from "luxon";

export function nowLiteral(tz: string) : DateTime<true> {
  const today = DateTime.local({ zone: tz });
  const todayLiteral = DateTime.fromISO(today.toISO({ includeOffset: false }), { zone: "UTC" });
  if(todayLiteral.isValid) return todayLiteral;
  throw new Error(`Invalid date ${today}`)
}

